import React from "react";
import ComingSoon from "@/Utility/ComingSoon/ComingSoon";

const UsersRolesSettings = () => {
  return (
    <div className="bg-surface-primary border border-border-primary rounded-md shadow-sm p-6">
      <ComingSoon title="Users & roles settings" />
    </div>
  );
};

export default UsersRolesSettings;
